import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { ModalProps } from '../../../../services/modals.service';
import { AlertService } from '../../../../services/alert.service';
import { useModalClose } from '../../../../utils/useModalClose';
import { InputWrapper } from '../../../common/input-wrapper';
import { Checkbox } from '../../../common/checkbox';
import { User, UserMultiSelect } from '../../../common/user-multi-select';
import { trpcSwr } from '../../../../api/trpc';

type FlagData = {
  id: number;
  name: string;
  enabledForAll: boolean;
  users: User[];
};

interface Props extends ModalProps {
  flag: FlagData;
  mutate: () => void;
}

type FormValues = {
  enabledForAll: boolean;
  users: User[];
};

export const FeatureFlagEditModal = ({ flag, mutate, close }: Props) => {
  const { control, handleSubmit, watch } = useForm<FormValues>({
    defaultValues: {
      enabledForAll: flag.enabledForAll,
      users: flag.users,
    },
  });

  const enabledForAll = watch('enabledForAll');

  const { trigger: update, isMutating } =
    trpcSwr.featureFlag.update.useSWRMutation();

  const onSubmit = handleSubmit(async (values) => {
    await update({
      id: flag.id,
      enabledForAll: values.enabledForAll,
      userUuids: values.enabledForAll ? [] : values.users.map((u) => u.id),
    });
    AlertService.success();
    mutate();
    close();
  });

  const modalRef = useModalClose(close);

  return (
    <div className="modal-dialog" ref={modalRef}>
      <div className="modal-content">
        <div className="modal-header border-bottom-0 p-4 d-flex gap-2">
          <div className="text-left mx-auto mt-1">
            <h5>Фича флаг: {flag.name}</h5>
          </div>
          <button type="button" className="btn-close" onClick={() => close()} />
        </div>
        <div className="modal-body pt-2 p-4">
          <form onSubmit={onSubmit}>
            <InputWrapper className="mb-3" title="Включён для всех">
              <Controller
                control={control}
                name="enabledForAll"
                render={({ field }) => (
                  <Checkbox
                    title="Для всех пользователей"
                    checked={field.value}
                    onChange={({ target: { checked } }) =>
                      field.onChange(checked)
                    }
                  />
                )}
              />
            </InputWrapper>

            {!enabledForAll && (
              <InputWrapper className="mb-3" title="Пользователи">
                <Controller
                  control={control}
                  name="users"
                  render={({ field }) => (
                    <UserMultiSelect
                      name={field.name}
                      value={field.value}
                      onChange={field.onChange}
                      onBlur={field.onBlur}
                      placeholder="Выберите пользователей"
                      roles={['admin', 'client', 'employee']}
                    />
                  )}
                />
              </InputWrapper>
            )}

            <button
              type="submit"
              className="btn btn-success w-100 mb-3 mt-4"
              disabled={isMutating}
            >
              Сохранить
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
